import { useEffect, useRef } from "react";
import { useState } from "react";
import { parseDate, stringifyDate } from "../utils/dateInput";

const fields = [
    {
        key: 'year',
        placeholder: 'YYYY',
        max: 9999,
        min: 1000,
        maxLength: 4,
    },
    {
        key: 'month',
        placeholder: 'MM',
        max: 12,
        min: 1,
        maxLength: 2,
    },
    {
        key: 'day',
        placeholder: 'DD',
        max: 31,
        min: 1,
        maxLength: 2,
    },
]

export default function InputPartialDate({name, disabled, value, onChange, className, inputRef}){

    const [formInput, setFormInput] = useState({
        month: '',
        day: '',
        year: '',
    });

    function onInputEvent(key, e){
        let value = e.target.value || '';
        const int = parseInt(value);
        if(!isNaN(int)){
            // limit number to within bounds
            const field = fields.find(f=>f.key == key);
            value = Math.max(int, field.min);
            value = Math.min(int, field.max);
        }
        // save new value
        const newVal = {...formInput, [key]: value}
        setFormInput(newVal);

        // send combined string value to parent
        const combined = stringifyDate(newVal);
        if(onChange) onChange({target: {value: combined}});
    }

    // parse incoming string value from parent
    useEffect(()=>{
        const split = parseDate(value || '');
        for(let field of fields){
            const value = split[field.key];
            // convert all zeros or undefined to blank
            if(!value || value === '0'.repeat(field.maxLength)){
                split[field.key] = '';
            }
        }
        setFormInput(split);
    },[value]);
    
    return (
        <div className={`flex ${className || ''}`}>
            {fields.map(field=>(
                <input
                    key={field.key}
                    id={name + '_' + field.key}
                    name={name + '_' + field.key}
                    placeholder={field.placeholder || ''}
                    className="p-1 mr-1"
                    disabled={disabled}
                    onChange={e=>onInputEvent(field.key, e)}
                    value={formInput[field.key]}
                    type="number"
                    max={field.max}
                    min={field.min}
                    maxLength={field.maxLength}
                    step={1}
                    ref={(field.key == 'year')?inputRef:undefined}
                />
            ))}
            
        </div>
    );
}